

import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { toBeDisabled } from '@testing-library/jest-dom';
import queryString from "query-string";
import $ from "jquery";
import CriacaoPenhora from './CriacaoPenhora';

const getnib = () => {
    (async () => {
      const queryParams = queryString.parse(window.location.search)
      const token = queryParams.idPenhora
      console.log(token ,"QUERY")
    
      if(token){
        const dataToken = {"idPenhora": token}
        var Detalhes = await services.apiCall.requestApi(
           "Receita/GetDetailsPenhoras",
           dataToken,
           "get"
        );
      }
      if(Detalhes){
        const filternib = {"idEntidade": Detalhes.idEntidadeOrdenante}
        const nib = await services.apiCall.requestApi(
           "/Receita/GETNibsDisp",
           filternib,
           "get"
        );
       $(".nibFill").val(nib.nib)
      }else{
        if($("#hiddenEntidade").val() != ""){
          const filternib = {"idEntidade": parseInt($("#hiddenEntidade").val())}
          const nib = await services.apiCall.requestApi(
             "/Receita/GETNibsDisp",
             filternib,
             "get"
          );
          if(nib == undefined){
            $("#botaoAdicionarNovo").attr("disabled" , true)
          }else{
            $("#botaoAdicionarNovo").attr("disabled" , false)
          }
         $(".nibFill").val(nib.nib)
        
        }
       
      }
       
     })();
}
// const getnib = e => {

 
export const NumericCell = props => {
    const handleChange = e => {
        if (props.onChange) {
          props.onChange({
            dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
          });
        }
      };

      const {
                dataItem
              } = props;
              var field = props.field || '';
              var dataValue = dataItem[field] === undefined ? '' : dataItem[field];
              var indexId = dataItem.ProductID;
              if(dataItem.inEdit == true){
                indexId = 0
              }
              console.log(dataItem)
              if (field == "descricao"){
                document.getElementsByClassName("textBoxDescricao")[indexId] == undefined ? dataItem[field] = "" : dataItem[field] = props.dataItem.idArtigo.descricao 
                dataValue = props.dataItem.idArtigo != undefined ? dataValue = props.dataItem.idArtigo.descricao : dataValue = ""
                  
              }
              if (field == "ValorUnitario"){
                if(document.getElementsByClassName("valorUnitarioFill")[indexId] != undefined){
                  dataItem[field] = document.getElementsByClassName("valorUnitarioFill")[indexId].value
                  dataValue = document.getElementsByClassName("valorUnitarioFill")[indexId].value
                }    
              }
              if (field == "iva"){
                if(document.getElementsByClassName("ivaFill")[indexId] != undefined){
                  dataItem[field] = document.getElementsByClassName("ivaFill")[indexId].value
                  dataValue = document.getElementsByClassName("ivaFill")[indexId].value
                }    
              }
              if (field == "nib"){
                getnib();
                if(document.getElementsByClassName("nibFill")[indexId] != undefined){
                  dataItem[field] = document.getElementsByClassName("nibFill")[indexId].value
                  dataValue = document.getElementsByClassName("nibFill")[indexId].value
                }    
              }
              if(field == "valor"){
                if(document.getElementsByClassName("textBox")[indexId]!= undefined){
                  dataItem[field] = document.getElementsByClassName("textBox")[indexId].value
                  dataValue = document.getElementsByClassName("textBox")[indexId].value
                }
                return <td>
                {dataItem.inEdit ? <input type="text" id='numberboxcell' className='textBox' onChange={handleChange} value={dataValue != null ? dataValue : dataValue.toString()} /> 
                : (dataValue != null ?  dataValue.toString() : undefined)}
              </td>
              //   return <td>
              //   {dataItem.inEdit ? <input type="text" id='numberboxcell' className='textBox' onChange={handleChange} /> : dataValue.toString()}
              // </td>
              }
              else if(field == "ValorUnitario"){
                return <td>
             {dataItem.inEdit ? <input type="text" id='numberboxcell' className='valorUnitarioFill' onChange={handleChange} value={dataValue != null ? dataValue : dataValue.toString()} disabled /> 
             : (dataValue != null ?  dataValue.toString() : undefined)}
           </td>
              }
              else if(field == "nib"){
                getnib();
                return <td>
             {dataItem.inEdit ? <input type="text" id='numberboxcell' className='nibFill' onChange={handleChange} value={dataValue != null ? dataValue : dataValue.toString()} disabled /> 
             : (dataValue != null ?  dataValue.toString() : undefined)}
           </td>
              }
              else if(field == "iva"){
                return <td>
             {dataItem.inEdit ? <input type="text" id='numberboxcell' className='ivaFill' onChange={handleChange} value={dataValue != null ? dataValue : dataValue.toString()} disabled /> 
             : (dataValue != null ?  dataValue.toString() : undefined)}
           </td>
              }
              else if(field == "descricao"){
                return <td>
             {dataItem.inEdit ? <input type="text" id='numberboxcell' className='textBoxDescricao' onChange={handleChange} value={dataValue != null ? dataValue : dataValue.toString()} disabled /> 
             : (dataValue != null ?  dataValue.toString() : undefined)}
           </td>
              }
            }
            
